<div class="row pb-4">
  <div class="col-12"></div>
</div>
<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <p-tabs
        value="0"
        *ngIf="isAdmin || isManager || isBac || isBc || isSuperManager">
        <p-tablist>
          <p-tab
            value="0"
            *ngIf="isAdmin || isManager || isBc || isSuperManager"
            >BC Dashboard</p-tab
          >
          <p-tab value="1" *ngIf="isAdmin || isBac || isSuperManager">
            Support Dashboard</p-tab
          >
          <p-tab value="2" *ngIf="isAdmin || isManager || isSuperManager"
            >BACM Dashboard</p-tab
          >
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="0">
            <jni-bc-report
              (openOrderListingModal)="openOrderListingModal($event)"
              (populateEvent)="populate($event)"></jni-bc-report>
          </p-tabpanel>
          <p-tabpanel value="1">
            <jni-bac-report
              (openOrderListingModal)="
                openOrderListingModal($event)
              "></jni-bac-report>
          </p-tabpanel>
          <p-tabpanel value="2">
            <jni-manager-report
              [isSuperManagerInput]="isSuperManager"
              [isAdmin]="isAdmin"></jni-manager-report>
          </p-tabpanel>
        </p-tabpanels> </p-tabs
    ></p-card>
  </div>
</div>

<!-- <p-tabs *ngIf="isAdmin || isManager || isBac || isBc || isSuperManager">
  <ng-container *ngIf="isAdmin || isManager || isBc || isSuperManager">
    <p-tabpanels header="BC Dashboard">
      <jni-bc-report></jni-bc-report>
    </p-tabpanels>
  </ng-container>
  <ng-container *ngIf="isAdmin || isBac || isSuperManager">
    <p-tabpanels header="Support Dashboard">
      <jni-bac-report></jni-bac-report>
    </p-tabpanels>
  </ng-container>

  <ng-container *ngIf="isAdmin || isManager || isSuperManager">
    <p-tabpanels header="BACM Dashboard">
      <jni-manager-report
        [isSuperManagerInput]="isSuperManager"
        [isAdmin]="isAdmin"></jni-manager-report>
    </p-tabpanels>
  </ng-container>
</p-tabs> -->

<jni-modal-stacker
  *ngIf="displayModalBacklog"
  [displayModal]="displayModalBacklog"
  (closeEvent)="closeBcLedgerModal()">
  <h1 class="panelHeading">
    {{ bcLedgerStacker.Path === 'YTDGP' ? 'YTD GP' : 'Backlog Details' }}
  </h1>
  <div class="panelBody">
    <jni-ytdgp
      *ngIf="bcLedgerStacker.Path === 'YTDGP'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-ytdgp>
    <jni-backlog-details
      *ngIf="bcLedgerStacker.Path === 'backlogdetails'"
      [bcLedgerStacker]="bcLedgerStacker"
      (closeModalEvent)="closeBcLedgerModal()">
    </jni-backlog-details>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="orderListingDisplayModal"
  [displayModal]="orderListingDisplayModal">
  <h1 class="panelHeading">Order Listing</h1>
  <div class="panelBody">
    <jni-orders
      [isAdditionalFilters]="true"
      [isFromSupportAllocation]="true"
      (openOrderListingModal)="openOrderListingModal($event)"></jni-orders>
  </div>
</jni-modal-stacker>
